// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuoteBlock{border:2px solid #7cb342;display:flex;margin-bottom:1rem;margin-top:1rem;padding:1rem}.QuoteBlock__wrapper:nth-child(2n) .QuoteBlock{flex-direction:row-reverse}.QuoteBlock__image{height:2rem}.QuoteBlock__text{margin-left:1rem;margin-right:1rem;margin-top:2rem}.QuoteBlock .Wysiwyg p{max-width:100%}.QuoteBlock__wrapper:nth-child(2n) .Wysiwyg p{text-align:right}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
